module.exports = {"data":{"dt":{"community":"ප්‍රජාව","projects":"ප්‍රධාන ව්‍යාපෘති","id":"සම්පූර්ණ අනන්‍යතාවය","org":"සංවිධානය"}}};